import { Request } from "../base/models.jsx";
import { Coordinate } from "../../utils/geographics/models.jsx";

const SERVICE_ID = 5;

class Event {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};
		
		this.id = jsonData.id;
		this.name = jsonData.name;
		this.description = jsonData.description;
		if (jsonData.location)
			this.location = new Coordinate(jsonData.location);

		this.shifts = [];
		if (jsonData.shifts) {
			for (var index = 0; index < jsonData.shifts.length; index++) {
				this.addShift(new EventShift(jsonData.shifts[index]));
			}
		}
	}

	addShift(shift) {
		this.shifts.push(shift);
	}

	isValid() {
		if (!this.name) return false;
		if (!this.description) return false;
		if (!this.location) return false;

		return true;
	}

}

class EventShift {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};
		
		this.id = jsonData.id;
		this.eventId = jsonData.eventId;
		this.date = jsonData.date;
		this.capacity = jsonData.capacity ? jsonData.capacity : 0;
		this.occupancy = jsonData.occupancy ? jsonData.occupancy : 0;

		if (jsonData.event)
			this.event = new Event(jsonData.event);
	}

	isValid() {
		if (!this.date) return false;
		if (this.capacity < 1) return false;
		if (this.occupancy < 0) return false;
		if (this.capacity < this.occupancy) return false;
		return true;
	}

}

class Reservation extends Request {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined) {
			jsonData = {};
			super(jsonData);
			this.creation();
		} else {
			super(jsonData);
		}
	
		this.shiftId = jsonData.shiftId;
		if (jsonData.shift)
			this.shift = new EventShift(jsonData.shift);
		
		this.attendees = [];
		if (jsonData.attendees) {
			for (var index = 0; index < jsonData.attendees.length; index++) {
				this.addAttendee(new Attendee(jsonData.attendees[index]));
			}
		}
	}

	creation() {
		super.creation();
		this.serviceId = SERVICE_ID;
	}

	addAttendee(attendee) {
		this.attendees.push(attendee);
	}

}

class Attendee {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};

		this.id = jsonData.id;
		this.requestId = jsonData.requestId;
		this.dni = jsonData.dni;
		this.name = jsonData.name;
		this.lastName = jsonData.lastName;
	}

}

export { Event, EventShift, Reservation }